import { render } from "./PricingPlansModal.vue?vue&type=template&id=712280ed&scoped=true"
import script from "./PricingPlansModal.vue?vue&type=script&lang=js"
export * from "./PricingPlansModal.vue?vue&type=script&lang=js"

import "./PricingPlansModal.vue?vue&type=style&index=0&id=712280ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712280ed"]])

export default __exports__